import { PERMISSIONS, SYSTEM_ROLES, type PermissionCode } from "./permissions.generated";

export { PERMISSIONS, SYSTEM_ROLES, type PermissionCode };
export type { SystemRoleKey } from "./permissions.generated";

/** Chave do papel com todas as permissões (única chave de papel com regra própria no sistema). */
export const OWNER_ROLE_KEY = "proprietario";

const CODES = new Set<string>(PERMISSIONS.map((p) => p.code));

export function isPermissionCode(value: string): value is PermissionCode {
  return CODES.has(value);
}

/** Módulos na ordem de exibição, com rótulo para a interface. */
export const PERMISSION_MODULES: Record<string, string> = {
  admin: "Administração",
  cadastros: "Cadastros",
  producao: "Produção",
  estoque: "Estoque",
  compras: "Compras e entradas",
  vendas: "Vendas",
  cargas: "Carga e acerto de vendedor",
  financeiro: "Financeiro",
  fiscal: "Fiscal",
  relatorios: "Relatórios e painel",
  contabilidade: "Contabilidade",
  app_vendedor: "Aplicativo do vendedor",
};
